import {
    captionClassName,
    pxArrayToRem,
    pxToRem,
    SubheaderClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const NoPinMobile: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),
    [`& .${captionClassName}`]: {
        width: pxToRem(293),
        fontSize: pxToRem(16),
        color: theme.siteVariables.colors.charcoal['000'],
        letterSpacing: theme.siteVariables.letterSpacingNormal,
        lineHeight: 1.4,
        textAlign: 'left',
    },
});
export const NoPinContentMobile: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(32),
    [theme.screen.tablet]: {
        marginBottom: 0,
    },
});

export const NoPinWithUpload: StyleRule = ({ theme, isDragActive }) => ({
    margin: pxArrayToRem([10, 1, 20, 52]),
    height: pxToRem(360),
    width: pxToRem(1511),
    border: isDragActive ? `1px dashed #464646` : 0, // can't find in aria
    background: isDragActive ? '#F6F6F6' : 'transparent', // can't find in aria
    borderRadius: pxToRem(4),
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',

    [`& > .${SubheaderClassName}`]: {
        fontSize: pxToRem(22),
        margin: pxArrayToRem(isDragActive ? [167, 0, 0, -8] : [134, 0, 18, 0]),
        opacity: isDragActive ? 0.5 : 1,
        color: theme.siteVariables.colors.charcoal['000'],
        letterSpacing: theme.siteVariables.letterSpacingSmall,
        textAlign: 'center',
    },

    [`& > .${captionClassName}`]: {
        fontSize: pxToRem(16),
        margin: pxArrayToRem([0, 0, 18, 0]),
        color: theme.siteVariables.colors.charcoal['000'],
        letterSpacing: theme.siteVariables.letterSpacingSmall,
        textAlign: 'center',

        '& span': {
            cursor: 'pointer',
            textDecoration: 'underline',
        },
    },
});

export const CallToActionContainer: StyleRule = () => ({
    margin: pxArrayToRem([0, 33, 0, 50]),
});

export const LoadingIcon: StyleRule = () => ({
    margin: pxArrayToRem([20, 0, 10, 0]),
});
